const baseStyle = () => {
  return {
    alignItems: 'flex-start'
  };
};

export default {
  baseStyle
};
//# sourceMappingURL=checkbox-group.js.map